import { useContext } from 'react';

import { PageTelemetryContext } from '../context';

export const usePageTelemetryContext = () => useContext(PageTelemetryContext);
